import { z } from "zod";

export const contactSchema = z.object({
  name: z
    .string()
    .trim()
    .min(2, "Zadejte prosím jméno (alespoň 2 znaky).")
    .max(120, "Jméno je příliš dlouhé."),
  email: z
    .string()
    .trim()
    .min(1, "Zadejte prosím e-mail.")
    .email("Zadejte prosím platnou e-mailovou adresu.")
    .max(200, "E-mail je příliš dlouhý."),
  phone: z
    .string()
    .trim()
    .max(120, "Telefon nebo web je příliš dlouhý.")
    .optional()
    .or(z.literal("")),
  message: z
    .string()
    .trim()
    .max(1200, "Zpráva může mít nejvýše 1200 znaků.")
    .optional()
    .or(z.literal("")),
  consent: z
    .boolean()
    .refine((value) => value === true, {
      message: "Bez souhlasu se zpracováním údajů nemůžeme poptávku odeslat.",
    }),
  company: z
    .string()
    .max(0, "Neplatné odeslání.")
    .optional()
    .or(z.literal("")),
});

export type ContactInput = z.infer<typeof contactSchema>;
